import { render } from "./clinic-list.vue?vue&type=template&id=13c13560&scoped=true"
import script from "./clinic-list.vue?vue&type=script&lang=js"
export * from "./clinic-list.vue?vue&type=script&lang=js"

import "./clinic-list.vue?vue&type=style&index=0&id=13c13560&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c13560"]])

export default __exports__